import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import Switcher from '../../../ui/Switcher';
import {
  animateDoors,
  getDoorsOpen,
  subscribeToDoorsOpen
} from '../../../ar3d/threeD/glbViewer/scene/modelsLoader/cabinetInterior/tallCabinetDoorsAnimator';

const OpenDoorsSwitcher = () => {
  const [doorsOpen, setDoorsOpen] = useState(() => getDoorsOpen());

  useEffect(() => subscribeToDoorsOpen(setDoorsOpen), []);

  const handleChange = (open) => {
    animateDoors(open);
  };

  return (
    <div className="sr__section sr__open-doors">
      <div className="sr__section-sides sr__open-doors-row">
        <span className="sr__open-doors-label">
          <FormattedMessage id="sqft.cabinets.attributes.openDoors" defaultMessage="Open Doors" />
        </span>
        <span>
          <Switcher value={doorsOpen} onChange={handleChange} />
        </span>
      </div>
    </div>
  );
};

export default OpenDoorsSwitcher;
